import { useContext } from 'react';
import { GlobalMobileContext } from '../../contexts/globalMobileContext'
import "./pages.css";
import TagComponent from '../../components/projectList/TagComponent';
import DetailCountComponent from '../../components/projectList/DetailCountComponent';

import styles from './Mobile_ProjectConferencesPage.module.css'

const Mobile_ProjectConferencesPage = () => {
    const { conferencesList, setCurrentPage, setCurrentConference } = useContext(GlobalMobileContext);

    const formatDate = (scheduleDateString, duration) => {
        const scheduledDate = new Date(scheduleDateString)

        const formattedDate = scheduledDate.toLocaleDateString("en-GB", {
            weekday: "short",
            day: "2-digit",
            month: "short"
        });

        const formatStartHour = scheduledDate.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })

        const endDate = new Date(scheduledDate.getTime() + duration * 60000);

        const formatEndHour = endDate.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });

        return formattedDate + " " + formatStartHour + " - " + formatEndHour
    }



    const openConference = (conference) => {
        setCurrentConference(conference)
        setCurrentPage("Conference menu")
    }


    return (
        <>
            <div className={styles.pagetitle}>
                <h1 className={styles.title}>Presentations & Conferences</h1>
            </div>

            <section className={styles.sectionScroll}>
                <div className={styles.row}>
                    <div>
                        {conferencesList.map((conference) => (
                            <div className={styles.cardConference} key={conference._id} onClick={() => openConference(conference)}>
                                <div className={styles.cardBody}>
                                    <div className={styles.cardTags}>
                                        <TagComponent status={conference.type} text={conference.type} fontSize={8} height={14} margin={0} padding="2px 8px" />
                                        <TagComponent status={conference.status} text={conference.status} fontSize={8} height={14} margin={0} padding="2px 8px" />
                                    </div>
                                    <h5 className={styles.cardTitle}>{conference.name}</h5>
                                    {conference.type !== "Presentation" && <div className={styles.detailsDate}>
                                        Date: <strong style={{ color: '#FFFFFF' }}>{formatDate(conference.scheduleDate, conference.duration)}</strong>
                                    </div>}
                                    <div className={styles.horizontalLine} />
                                    <div className={styles.cardTags}>
                                        <DetailCountComponent project={conference} type={"nrNotes"} style={{ fontSize: "12px", lineHeight: "14px", gap: "2px", marginLeft: 0 }}
                                            iconFontSize={10} iconMargin="2px 5px 0px 0px" compMargin="10px 13px 0px 0px" />
                                        <DetailCountComponent project={conference} type={"nrFiles"} style={{ fontSize: "12px", lineHeight: "14px", gap: "2px", marginLeft: 0 }}
                                            iconFontSize={10} iconMargin="2px 5px 0px 0px" compMargin="10px 13px 0px 0px" />
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                <div className='topShadow' style={{ top: "65px" }} />
                <div className='bottomShadow' />
            </section>


        </>
    );
}

export default Mobile_ProjectConferencesPage;
